import React, { FC, lazy } from 'react';
import { modalRoutes } from 'constants/routes';
import ModalRoute, { ModalRouteProps } from 'context/ModalRouter';
import PlanLimitReachedModal from 'app/components/modals/planLimitReached/PlanLimitReachedModal';
import InviteUserModal from './invitation/InviteUserModal';
import DisconnectedProfilesModal from 'app/modules/settings/modules/me/modules/authorization/components/modals/DisconnectedProfilesModal';
import UserPermissionGate from 'components/UserPermissionGate';
import { UserPermission } from 'constants/userPermission';
import CreateContentPlanPage from 'app/modules/posts/modules/createContentPlan';
import FirstPostApprovedModal from 'app/components/modals/firstTimeFlags/firstPostApproved/FirstPostApprovedModal';
import FirstApprovalRequestedModal from 'app/components/modals/firstTimeFlags/firstApprovalRequested/FirstApprovalRequestedModal';
import SubscriptionExpired from 'app/components/subscriptionModals/SubscriptionExpired';

const UserLimitReachedRoute: FC<ModalRouteProps> = (props) => (
  <PlanLimitReachedModal {...props} variant="user" />
);

const SubscriptionExpiredRoute: FC<ModalRouteProps> = ({ modalManager }) => (
  <SubscriptionExpired modalManager={modalManager} />
);

const ManageProfileGroup = lazy(
  () => import('pages/posts/post/ManageProfileGroup'),
);

const CommonModals: FC = () => (
  <>
    <ModalRoute
      path={modalRoutes.PROFILE_LIMIT_REACHED}
      component={PlanLimitReachedModal}
    />
    <ModalRoute
      path={modalRoutes.USER_LIMIT_REACHED}
      component={UserLimitReachedRoute}
    />
    <ModalRoute
      path={modalRoutes.SUBSCRIPTION}
      component={SubscriptionExpiredRoute}
    />
    <ModalRoute path={modalRoutes.INVITE_USER} component={InviteUserModal} />
    <ModalRoute
      path={modalRoutes.DISCONNECTED_PROFILES}
      component={DisconnectedProfilesModal}
    />
    <UserPermissionGate scopes={UserPermission.PROJECT_CREATE}>
      <ModalRoute
        path={modalRoutes.NEW_CONTENT_PLAN}
        component={CreateContentPlanPage}
      />
    </UserPermissionGate>
    <ModalRoute
      path={modalRoutes.FIRST_POST_APPROVED}
      component={FirstPostApprovedModal}
    />
    <FirstApprovalRequestedModal />
    <UserPermissionGate scopes={UserPermission.PAGE_PRESETS_MANAGE}>
      <ModalRoute
        path={modalRoutes.MANAGE_PROFILE_GROUP}
        component={ManageProfileGroup}
      />
    </UserPermissionGate>
  </>
);

export default CommonModals;
